<template>
    <div class="ai-search-widget" :id="elId">
        <div class="ai-flex-line-form" id="frm-search">
            <div class="search-direction">
                <div class="search-label"><span>Поиск</span></div>
                <DxDropDownButton
                    class="search-area"
                    :data-source="whatSearch"
                    :dropDownOptions="dropDownOptions"
                    keyExpr="id"
                    displayExpr="name"
                    stylingMode="text"
                    useSelectMode="true"
                    :text="selectedWhat.name"
                    @item-click="onWhatClick"
                />

                <div class="search-label"><span>по</span></div>
                <DxDropDownButton
                    class="search-area"
                    :data-source="selectedWhat.where"
                    :dropDownOptions="dropDownOptions"
                    keyExpr="code"
                    displayExpr="name"
                    :text="selectedWhere.name"
                    @item-click="onWhereClick"
                />
            </div>
            <div class="search-value">
                <DxTextBox
                    v-model:value="searchText"
                    :hint="selectedWhere.hint"
                    :placeholder="selectedWhere.hint"
                    @key-up="onKeyUp"
                >
                </DxTextBox>
            </div>
            <div class="search-options">
                <DxButton
                    icon="/infoenergo/assets/search/state-all.svg"
                    hint="Включая архивные"
                    :stylingMode="activeOnly ? 'outlined' : 'contained'"
                    type="default"
                    @click="toggleActive"
                />
                <DxButton
                    icon="/infoenergo/assets/search/not-exact.svg"
                    hint="Неточное совпадение"
                    :stylingMode="isEqual ? 'outlined' : 'contained'"
                    type="default"
                    @click="toggleEqual"
                />
                <DxButton
                    icon="/infoenergo/assets/search/complex.svg"
                    hint="Конструктор условий"
                    type="default"
                    styling-mode="outlined"
                    @click="showFilterBuilder"
                />
            </div>
            <div class="search-button">
                <DxButton text="Искать" type="default" @click="onSearchClick" />
            </div>
        </div>

        <dx-popup
            v-model:visible="builderVisible"
            :height="500"
            :width="500"
            :showHeader="true"
            :showTitle="true"
            :title="'Конструктор условий!'"
            :showCloseButton="true"
            :closeOnOutsideClick="false"
            :resize-enabled="true"
            :drag-enabled="true"
        >
            <div class="popup-box">
                <div class="popup-body">
                    <DxFilterBuilder :fields="fields" v-model:value="filterValue"> </DxFilterBuilder>
                </div>
                <div class="popup-footer">
                    <DxButton text="Отмена" class="mr-10" @click="onBuilderCancel" />
                    <DxButton text="Искать" type="default" class="popup-footer" @click="onBuilderOk" />
                </div>
            </div>
        </dx-popup>
    </div>
</template>

<script>
export default {
    name: 'ai-search-widget',
};
</script>
<script setup>
import { ref, defineProps, onBeforeMount, onMounted } from 'vue';
import { DxPopup } from 'devextreme-vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import DxFilterBuilder from 'devextreme-vue/filter-builder';
import { getURL } from '@/service/http';
import { getUserDataChanges, saveUserDataChanges } from '@/service/userdata-service';

// import iconStateAll from "@/../assets/icon.svg";
// new DevExpress.ui.dxButton(targetElement, {
//     icon: myIcon
// });

const VIEW_ID = 'search-form';
const INSTANCE_ID = 1;

const emit = defineEmits(['search', 'search-start', 'search-end', 'focusin', 'force']);

const props = defineProps({
    keyExpr: {
        type: String,
        default: () => 'id',
    },
    dispayExpr: {
        type: String,
        default: () => 'name',
    },
    elId: {
        type: String,
    },
    text: {
        type: String,
    },
    entities: {
        type: Array,
    },
    svg: {
        type: String,
    },
    searchComponentName: {
        type: String,
    },
});

const dropDownOptions = {
    class: 'search-area',
    width: 400,
    // height: 'inherit'
};

const builderVisible = ref(false);
// const positionOf = ref('');
const isEqual = ref(false);
const activeOnly = ref(true);
const selectedWhat = ref({});
const selectedWhere = ref({});
const searchText = ref('');

const whatSearch = ref([
    {
        id: 'dog',
        name: 'договора',
        where: [
            {
                code: 'dog.num',
                name: 'номеру',
                hint: 'Укажите номер или его часть',
            },
            {
                code: 'abn.inn',
                name: 'ИНН абонента',
                hint: 'Укажите ИНН абонента',
            },
            {
                code: 'abn.name',
                name: 'названию абонента',
                hint: 'Укажите название или его часть',
            },
        ],
    },
    {
        id: 'abn',
        name: 'абонента',
        where: [
            {
                code: 'abn.name',
                name: 'названию',
                hint: 'Укажите название или его часть',
            },
            {
                code: 'abn.inn',
                name: 'ИНН',
                hint: 'Укажите ИНН',
            },
            {
                code: 'abn.kpp',
                name: 'КПП',
                hint: 'Укажите КПП',
            },
            {
                code: 'abn.ogrn',
                name: 'ОГРН',
                hint: 'Укажите ОГРН',
            },
            {
                code: 'abn.addr',
                name: 'адресу',
                hint: 'Укажите часть адреса',
            },
        ],
    },
    {
        id: 'obj',
        name: 'объекта',
        hint: 'что-то еще',
        where: [
            {
                code: 'dog.num',
                name: 'номеру договора',
                hint: 'Укажите номер или его часть',
            },
            {
                code: 'obj.num',
                name: 'номеру',
                hint: 'Укажите номер или его часть',
            },
            {
                code: 'abn.inn',
                name: 'ИНН абонента',
                hint: 'Укажите ИНН',
            },
            {
                code: 'abn.name',
                name: 'названию абонента',
                hint: 'Укажите название или его часть',
            },
        ],
    },
    {
        id: 'pnt',
        name: 'точки учета',
        where: [
            {
                code: 'cnt.num',
                name: 'номеру прибора учета',
                hint: 'Укажите номер или его часть',
            },
            {
                code: 'obj.num',
                name: 'номеру объекта',
                hint: 'Укажите номер или его часть',
            },
            {
                code: 'pnt.num',
                name: 'номеру',
                hint: 'Укажите номер или его часть',
            },
            {
                code: 'pnt.name',
                name: 'названию',
                hint: 'Укажите название или его часть',
            },
            {
                code: 'dog.num',
                name: 'номеру договора',
                hint: 'Укажите номер или его часть',
            },
            {
                code: 'abn.inn',
                name: 'ИНН абонента',
                hint: 'Укажите ИНН',
            },
            {
                code: 'abn.name',
                name: 'названию абонента',
                hint: 'Укажите название абонента',
            },
        ],
    },
]);

const filter = [
    // ['Product_Current_Inventory', '<>', 0],
    // 'or',
    // [['Product_Name', 'contains', 'HD'], 'and', ['Product_Cost', '<', 200]],
];
const filterValue = ref(filter);
const fields = [
    {
        caption: 'ID',
        width: 50,
        dataField: 'Product_ID',
        dataType: 'number',
    },
    {
        dataField: 'Product_Name',
        dataType: 'string',
    },
    {
        caption: 'Cost',
        dataField: 'Product_Cost',
        dataType: 'number',
        format: 'currency',
    },
    {
        dataField: 'Product_Sale_Price',
        caption: 'Sale Price',
        dataType: 'number',
        format: 'currency',
    },
    {
        dataField: 'Product_Retail_Price',
        caption: 'Retail Price',
        dataType: 'number',
        format: 'currency',
    },
    {
        dataField: 'Product_Current_Inventory',
        dataType: 'number',
        caption: 'Inventory',
    },
];

onBeforeMount(() => {
    getURL(`/infoenergo/assets/${props.svg}`);
    // console.log(`store.state.userDataDetails: `, store.state.userDataDetails);
    // const x = filterValue;
    // x.y = fields;
});

onMounted(async () => {
    const what = whatSearch.value[0];
    selectedWhat.value = what;
    selectedWhere.value = what.where[0];

    const data = await getUserData();
    applySearchEventData(data.changes);
});

const onWhatClick = e => {
    selectedWhat.value = e.itemData;
    selectedWhere.value = e.itemData.where[0];
};

const onWhereClick = e => {
    selectedWhere.value = e.itemData;
};

const onKeyUp = e => {
    if (e.event.keyCode == 13) {
        doSearch(e);
    }
};

const onSearchClick = e => {
    doSearch(e);
};

const doSearch = e => {
    console.log('ai-search-form.doSearch', e);
    const data = buildSearchEventData();
    sendUserData(data);
    emit('search', data);
};

// запомненные данные приходят здесь
const getUserData = async () => {
    const args = {
        viewId: VIEW_ID,
        instanceId: INSTANCE_ID,
    };
    const x = await getUserDataChanges(args);
    console.log(`${VIEW_ID}:getUserDataChanges userData: `, x);
    if (x.changes) {
        // bridge.updateControls(x.changes);
    }
    return x;
};

const sendUserData = async data => {
    const args = {
        viewId: VIEW_ID,
        instanceId: INSTANCE_ID,
        changes: data,
    };

    const answer = await saveUserDataChanges(args);
    console.log(`${VIEW_ID}:saveUserDataChanges answer: `, args, answer);
    return answer;
};

const showFilterBuilder = e => {
    builderVisible.value = true;
};

const toggleEqual = e => {
    isEqual.value = !isEqual.value;
};

const toggleActive = e => {
    activeOnly.value = !activeOnly.value;
};

const buildSearchEventData = () => {
    const data = {
        what: selectedWhat.value.id,
        where: selectedWhere.value.code,
        isEqual: isEqual.value,
        activeOnly: activeOnly.value,
        text: searchText.value,
    };
    return data;
};

const getWhatByCode = code => {
    const res = whatSearch.value.find(e => e.id === code);
    return res || {};
};

const getWhereByCode = code => {
    if (selectedWhat.value?.where) {
        const res = selectedWhat.value.where.find(e => e.code === code);
        return res || {};
    } else {
        return {};
    }
};

const applySearchEventData = data => {
    if (data) {
        selectedWhat.value = getWhatByCode(data.what);
        selectedWhere.value = getWhereByCode(data.where);

        // selectedWhat.value.id = data.what;
        // selectedWhere.value.code = data.where;
        isEqual.value = data.isEqual;
        activeOnly.value = data.activeOnly;
        searchText.value = data.text;
    }
};

const onBuilderCancel = e => {
    builderVisible.value = false;
};

const onBuilderOk = e => {
    builderVisible.value = false;
    filterValue.value = e;
    doSearch();
};
</script>

<style scoped>
/* .dx-button-mode-contained.dx-buttongroup-last-item,
.dx-button-mode-outlined.dx-buttongroup-last-item,
.dx-button:last-child {
    border-inline-end: none !important;
    border-right: none !important;
} */

.popup-box {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.popup-body {
    flex-grow: 1;
    padding: 10px;
}

.popup-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.mr-10 {
    margin-right: 10px;
}

:deep(#frm-search) * {
    font-size: 1rem;
}

:deep(#frm-search .dx-button-text) {
    text-transform: none !important;
}

:deep(#frm-search .dx-buttongroup-last-item) {
    border-right-width: 0;
}

:deep(#frm-search .dx-dropdownbutton) {
    margin-right: 24px;
    border-radius: 0;
}

:deep(#frm-search .dx-dropdownbutton .dx-button-content) {
    padding-left: 4px;
}

:deep(#frm-search .dx-dropdownbutton .dx-button) {
    border: none;
    border-bottom: 1px #cdd0d3 solid;
    border-radius: 0;
}

:deep(#frm-search .dx-button-has-icon) {
    border: none;
}

:deep(#frm-search .dx-button-has-icon .dx-icon) {
    width: 36px;
    height: 36px;
    padding: 2px;
}

:deep(#frm-search .dx-texteditor-input) {
    color: #031426cc;
}

:deep(#frm-search .ai-flex-line-form .search-options) {
    padding-top: 0 !important;
}

:deep(#frm-search .search-options .dx-button) {
    background-color: transparent;
    margin: 0px 6px;
    height: 42px;
}

:deep(#frm-search .search-options .dx-button .dx-button-content) {
    padding: 0;
}

:deep(#frm-search .search-options .dx-icon:hover) {
    /* background-color: #a9ffc7ff; */
    /* border-radius: 50%; */
}

/* .dx-button-mode-contained */
/* .dx-button-mode-outlined */

:deep(#frm-search .dx-button-mode-contained) {
    box-shadow: none;
}

:deep(#frm-search .dx-button-mode-contained .dx-icon) {
    border: solid 2px #286eb6;
    border-radius: 50%;
}

:deep(#frm-search .dx-button-has-text .dx-button-content) {
    padding-left: 8px;
}

:deep(#frm-search .search-button) {
    padding-top: 2px;
    margin-left: 24px;
}

:deep(#frm-search .search-button .dx-button) {
    height: 36px;
    width: 150px;
}

:deep(#frm-search .dx-icon-spindown) {
    color: #cdd0d3;
    font-size: 1.3rem;
}

:deep(div.dx-list-item.dx-state-hover) {
    color: red;
}

.ai-flex-line-form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
    gap: 10px;
    width: 100%;
}

.ai-flex-line-form .search-direction {
    padding-top: 6px;
}

.ai-flex-line-form .search-label {
    padding-top: 2px;
    display: inline-block;
    white-space: nowrap;
    color: #286eb6;
    font-weight: 500;
    margin-right: 12px;
}

.ai-flex-line-form .search-area {
    flex-grow: 0;
    margin-top: -3px;
    /* border: none !important;
    border-bottom: 2px solid #e3e9ef !important;
    background: transparent !important;  */
}

.ai-flex-line-form .search-button {
}

.ai-flex-line-form .search-button .dx-button.dx-button-default {
    border-radius: 5px;
    background-color: #286eb6ff;
}

.search-value {
    flex-grow: 1;
    margin-right: 24px;
}

.search-value .dx-textbox {
    flex-grow: 1;
    border-radius: 5px;
    border: none;
    background-color: #d0e7ff;
}

.ai-search-widget {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
}

.ai-search-widget-text {
    font-size: 22px;
    font-weight: 300;
    color: #000;
    padding-top: 5px;
    padding-bottom: 5px;
}
.dx-placeholder {
    font-size: 15px;
}

:deep(.dx-item.dx-list-item.dx-state-hover) {
    background-color:#ccc!important;
}
.dx-item.dx-list-item.dx-state-hover {
    background-color:#ccc!important;
}

</style>
